export default __webpack_public_path__ + "static/media/girl-eating@3x.306ce382.png";